import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from '../../../../core/services/GenericService';
import { ApiService } from '../../../../core/services';
import { IRecipeCard } from '../interfaces/IRecipeCard';

@Injectable({
  providedIn: 'root'
})
export class RecipeCardsFinderService extends GenericService<IRecipeCard> {
  protected readonly baseUrl = '/recipeCards';

  constructor(public apiService: ApiService) {
    super(apiService);
  }

  public getByEan(ean: string): Observable<IRecipeCard[]> {
    return this.apiService.get(`${ this.baseUrl }/by-ean/${ encodeURIComponent(ean) }`);
  }

  public getByVariantId(variantId: number): Observable<IRecipeCard> {
    return this.apiService.get(`${ this.baseUrl }/by-variant/${ variantId }`);
  }

  public getByNumber(number: number): Observable<IRecipeCard> {
    return this.apiService.get(`${ this.baseUrl }/by-number/${ number }`);
  }

  public setArticles(id: number, articleIds: number[]): Observable<void> {
    return this.apiService.put(`${ this.baseUrl }/${ id }/articles`, { articleIds });
  }

  public createCard(card: Partial<IRecipeCard>): Observable<number> {
    return this.apiService.post(`${ this.baseUrl }`, card);
  }

  public updateCard(id: number, card: Partial<IRecipeCard>): Observable<void> {
    return this.apiService.put(`${ this.baseUrl }/${ id }`, card);
  }
}
